import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Head from './Head/Head';
import List from './List/List';
import './Program.css';

// todo - probably rename to Programme
// todo - polish detail open check stuff - lot of repeating code - but it seems to work - maybe save 'detailOpen' value into state after all

class Program extends Component {
  constructor(props) {
    super(props);
    this.state = {
      topScroll: 0
    };

    this.handleScroll = this.handleScroll.bind(this);
  }

  // -------------------------------------------------------
  // Component
  // -------------------------------------------------------

  componentWillMount() {
    this.categoryScroll = 0; // note - revise scroll stuff
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      topScroll:
        nextProps.location.pathname.indexOf('detail') !== -1
          ? this.categoryScroll
          : 0
    });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.location.pathname.indexOf('detail') !== -1 &&
      this.props.location.pathname.indexOf('detail') === -1
    ) {
      window.scrollTo(0, this.categoryScroll);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  // -------------------------------------------------------
  // Scroll
  // -------------------------------------------------------

  handleScroll() {
    if (this.props.location.pathname.indexOf('detail') === -1) {
      this.categoryScroll = document.documentElement.scrollTop;
    }
  }

  // -------------------------------------------------------
  // Render
  // -------------------------------------------------------

  render() {
    const { location } = this.props;

    // todo - temp
    const detailActive = location.pathname.indexOf('detail') !== -1;

    // todo - temp solution - not ideal
    const mainClass = detailActive ? 'entry' : 'program';

    return (
      <div id="program" className={mainClass}>
        <Head />
        <List topScroll={this.state.topScroll} />
      </div>
    );
  }
}

export default withRouter(Program);



// WEBPACK FOOTER //
// ./src/components/App/Program/Program.js